<ng-template #headerTemplate>
  <app-system-selection-header></app-system-selection-header>
</ng-template>
<div class="horizontal-container" *appLoading="showSpinner$ | async">
  <div class="vertical-container unselected">
    @if (unselectedSystems$ | async; as unselectedSystems) {
    <div class="subheader">
      <span class="subtitle">systems to select</span>
      <button class="iconf-btn-blank minw150" (click)="onSelectAllSystems(unselectedSystems)">
        <mat-icon>check</mat-icon>
        <span>select all</span>
      </button>
    </div>
    }

    <div class="scroll-container">
      @if (unselectedProcessSystems$ | async; as processSystems) {
      <app-system-list
        title="Process"
        [systems]="processSystems"
        [isSelected]="false"
        (selectSystem)="onSelectSystem($event)"
        (selectAllSystems)="onSelectAllSystems($event)"
      >
      </app-system-list>
      } @if (unselectedUtilitySystems$ | async; as utilitySystems) {
      <app-system-list
        title="Utility"
        [systems]="utilitySystems"
        [isSelected]="false"
        (selectSystem)="onSelectSystem($event)"
        (selectAllSystems)="onSelectAllSystems($event)"
      >
      </app-system-list>
      }
    </div>
  </div>
  <app-separator></app-separator>
  <div class="vertical-container selected">
    @if (selectedSystems$ | async; as selectedSystems) {
    <div class="subheader">
      <span class="subtitle">systems selected</span>
      <button class="iconf-btn-blank minw150" (click)="onRemoveAllSystems(selectedSystems)">
        <mat-icon>check</mat-icon>
        <span>remove all</span>
      </button>
    </div>
    }

    <div class="scroll-container">
      @if (selectedProcessSystems$ | async; as processSystems) { @if (selectedUtilitySystems$ | async; as utilitySystems) { @if
      (processSystems.length + utilitySystems.length == 0) {
      <app-placeholder [icon]="noSystemsSelectIcon" title="add systems" description="Select systems by clicking on  + select link">
      </app-placeholder>
      } @else {
      <app-system-list
        title="Process"
        [systems]="processSystems"
        [isSelected]="true"
        (removeSystem)="onRemoveSystem($event)"
        (removeAllSystems)="onRemoveAllSystems($event)"
      >
      </app-system-list>
      <app-system-list
        title="Utility"
        [systems]="utilitySystems"
        [isSelected]="true"
        (removeSystem)="onRemoveSystem($event)"
        (removeAllSystems)="onRemoveAllSystems($event)"
      >
      </app-system-list>
      }
      <ng-template #selected>
        <app-system-list
          title="Process"
          [systems]="processSystems"
          [isSelected]="true"
          (removeSystem)="onRemoveSystem($event)"
          (removeAllSystems)="onRemoveAllSystems($event)"
        >
        </app-system-list>
        <app-system-list
          title="Utility"
          [systems]="utilitySystems"
          [isSelected]="true"
          (removeSystem)="onRemoveSystem($event)"
          (removeAllSystems)="onRemoveAllSystems($event)"
        >
        </app-system-list>
      </ng-template>
      } }
    </div>
  </div>
</div>

<ng-template #footerTemplate>
  <app-system-selection-footer>
    <button
      [disabled]="systemsToConfigure.length < 1"
      class="iconf-btn-filled minw200 minh40"
      [routerLink]="systemsToConfigureRouterLink"
      [queryParams]="systemsToConfigureQueryParams"
      queryParamsHandling="merge"
    >
      configure new systems
    </button>
  </app-system-selection-footer>
</ng-template>
